import React, { Component } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { connect } from "react-redux";
import Logo from '../assets/images/logo/DAB-logo-2.png'
import { clearFilterExcept } from "./common/functions";
import { getCurrentUser } from "../services/selectors/Accounts";

interface IHeaderProps {
	sessionTimeout: number;
	login: any;
	loginData: any;
	userName: string;
	isAdmin: boolean;
	isLogged: boolean;
}

interface IHeaderState {
	dropdownFeedOpen: boolean;
	dropdownCommunityOpen: boolean;
	messageBoardSubMenuOpen: boolean;
	dropdownShopOpen: boolean;
	dropdownDonationsOpen: boolean;
	islocalTimerStart: boolean;
	isTimeOutCalled: boolean;
	CHECK_INTERVAL: number;
	showTCModal: boolean;
	userRoles: string;
}

class Header extends Component<IHeaderProps, IHeaderState> {
	constructor(props) {
		super(props);
		this.state = {
			dropdownFeedOpen: false,
			dropdownCommunityOpen: false,
			messageBoardSubMenuOpen:false,
			dropdownShopOpen: false,
			dropdownDonationsOpen: false,
			islocalTimerStart: false,
			isTimeOutCalled: false,
			CHECK_INTERVAL: 60000, 
			showTCModal: false,
			userRoles: "",
		};
		this.handleToggle = this.handleToggle.bind(this);
		this.handleNavigate = this.handleNavigate.bind(this);
	}

	componentDidMount() {		
		const user = getCurrentUser();
		if (user != null) {
			this.setState({ userRoles: user.info.roleCodes })
		}
	}

	handleToggle() {
		this.setState(prevState => ({
			dropdownFeedOpen: !prevState.dropdownFeedOpen
		}));
	}

	handleRefreshTimeOut() {
		const loggedInString = localStorage.getItem('AUTHDATA');
		if (loggedInString) {
			setTimeout(() => {
				this.setState({ isTimeOutCalled: true });
			}, this.props.sessionTimeout * 60000);
		}
	}

	handleNavigate(url: string) {
		clearFilterExcept();
		sessionStorage.removeItem("createEpisode");
		sessionStorage.removeItem("fromPage");
		sessionStorage.removeItem("Filter");
		sessionStorage.removeItem("memoryRoute");
		sessionStorage.removeItem("fromPath");
		localStorage.removeItem("bibleId");
		localStorage.removeItem("langCode");
		localStorage.removeItem("channelId");
		sessionStorage.removeItem("userId");
		sessionStorage.removeItem("resFilter");
		window.location.href = url;
	}
	handleNavigateDonations() {
		window.open("https://dashboard.stripe.com/")
	}

	handleNavigateShop() {
		window.open ("https://dailyaudiobible.myshopify.com/admin ")
	}

	public render() {
		const frontLogged = sessionStorage.getItem('fp-Log');
		return (
			<div className='containers'>
				<nav className={(window.location.pathname != '/front' && window.location.pathname != '/unauth') ? 'navbar' : 'navbar front-navbar'}>
					{this.props.isLogged && window.location.pathname != '/front'?
						<a href={this.props.isLogged ? '/' : '/login'} className='logo-a'><img alt="Daily Audio Bible" src={Logo} /></a> :
						<div className='logo-a'><img alt="Daily Audio Bible" src={Logo} /></div>}
					<div className='toolbar' style={{
						display: `${(this.props.isLogged && window.location.pathname != '/forgotpassword'
							&& window.location.pathname != '/front' && window.location.pathname != '/unauth' && !frontLogged) ? "" : 'none'}`
					}}>
						{(this.state.userRoles.includes('Admin') ||
							this.state.userRoles.includes('Channel') ||
							this.state.userRoles.includes('Episode')) &&
							<Dropdown className='dropdown' direction="down" isOpen={this.state.dropdownFeedOpen}
								onMouseOver={() => this.setState({ dropdownFeedOpen: true })}
								onFocus={() => this.setState({ dropdownFeedOpen: true })}
								onMouseLeave={() => this.setState({ dropdownFeedOpen: false })}
								onBlur={() => this.setState({ dropdownFeedOpen: false })}
								toggle={() => this.setState({ dropdownFeedOpen: !this.state.dropdownFeedOpen })}
							>
								<DropdownToggle>
									<span data-testid="homePageHeader"> Feed </span>
								</DropdownToggle>
							{(this.state.userRoles.includes('Admin') ||
								this.state.userRoles.includes('Channel')) ?
								<DropdownMenu className='dropdown-menu'>
									<DropdownItem onClick={this.handleNavigate.bind(this, '/channel')} data-testid="channel-Menu">Channels</DropdownItem>
									<DropdownItem onClick={this.handleNavigate.bind(this, '/episode')} data-testid="episode-Menu">Episodes</DropdownItem>
									<DropdownItem onClick={this.handleNavigate.bind(this, '/bible')} data-testid="bible-Menu">Bibles</DropdownItem>
									<DropdownItem onClick={this.handleNavigate.bind(this, '/readingplan')} data-testid="readingplan-Menu">Reading Plans</DropdownItem>
								</DropdownMenu> :
								<DropdownMenu className='dropdown-menu'>
									<DropdownItem onClick={this.handleNavigate.bind(this, '/episode')} data-testid="episode-Menu">Episodes</DropdownItem>
								</DropdownMenu>}
							</Dropdown>}
						{(this.state.userRoles.includes('Admin') || this.state.userRoles.includes('Community')) &&
							<Dropdown className='dropdown' direction="down" isOpen={this.state.dropdownCommunityOpen}
								onMouseOver={() => this.setState({ dropdownCommunityOpen: true })}
								onFocus={() => this.setState({ dropdownCommunityOpen: true })}
								onMouseLeave={() => this.setState({ dropdownCommunityOpen: false })}
								onBlur={() => this.setState({ dropdownCommunityOpen: false })}
								toggle={() => this.setState({ dropdownCommunityOpen: !this.state.dropdownCommunityOpen })}>
								<DropdownToggle>
									<span data-testid="community-Header"> Community </span>
								</DropdownToggle>
								<DropdownMenu className='dropdown-menu'>
									<DropdownItem className="custom-menu">
										{(this.state.userRoles.includes('Admin'))&&
										<Dropdown className='dropdowns sub-menu d-inline-block submenu' direction="end"
											isOpen={this.state.messageBoardSubMenuOpen}
											onMouseOver={() => this.setState({ messageBoardSubMenuOpen: true })}
											onFocus={() => this.setState({ messageBoardSubMenuOpen: true })}
											onMouseLeave={() => this.setState({ messageBoardSubMenuOpen: false })}
											onBlur={() => this.setState({ messageBoardSubMenuOpen: false })}											
											toggle={() => this.setState({ messageBoardSubMenuOpen: !this.state.messageBoardSubMenuOpen })}>
											<DropdownToggle caret onClick={this.handleNavigate.bind(this, '/messageboard')}>
												<div className="submenu-item sd" data-testid="messageboard-Menu">Message Boards</div>
											</DropdownToggle>
											<DropdownMenu>
												<DropdownItem onClick={this.handleNavigate.bind(this, '/messageboard?page=topics&code=prayerwall')} data-testid="prayerWall-Menu">Prayer Wall</DropdownItem>
												<DropdownItem onClick={this.handleNavigate.bind(this, '/messageboard?page=topics&code=hotline')} data-testid="hotline-Menu">Hotline</DropdownItem>
											</DropdownMenu>
										</Dropdown>
										}

									</DropdownItem>																		
									<DropdownItem onClick={this.handleNavigate.bind(this, '/dashboard')} data-testid="dashboard-Menu">User Management</DropdownItem>
								</DropdownMenu>
							</Dropdown>}

						{this.state.userRoles.includes('Admin')  &&
							< Dropdown className='dropdown' direction="down" isOpen={this.state.dropdownShopOpen}
								onMouseOver={() => this.setState({ dropdownShopOpen: true })}
								onFocus={() => this.setState({ dropdownShopOpen: true })}
								onMouseLeave={() => this.setState({ dropdownShopOpen: false })}
								onBlur={() => this.setState({ dropdownShopOpen: false })}
								toggle={() => this.setState({ dropdownShopOpen: !this.state.dropdownShopOpen })}>
								<DropdownToggle onClick={this.handleNavigateShop}>
									<span data-testid="shop-Header"> Shop </span>
								</DropdownToggle>
						</Dropdown>}
						{this.state.userRoles.includes('Admin') &&
							<Dropdown className='dropdown' direction="down" isOpen={this.state.dropdownDonationsOpen}
								onMouseOver={() => this.setState({ dropdownDonationsOpen: true })}
								onFocus={() => this.setState({ dropdownDonationsOpen: true })}
								onMouseLeave={() => this.setState({ dropdownDonationsOpen: false })}
								onBlur={() => this.setState({ dropdownDonationsOpen: false })}
								toggle={() => this.setState({ dropdownDonationsOpen: !this.state.dropdownDonationsOpen })}>
								<DropdownToggle onClick={this.handleNavigateDonations}>
									<span data-testid="donation-Header"> Donations </span>
								</DropdownToggle>
						</Dropdown>}
					</div>
					<div className="collapse navbar-collapse">
					</div>
				</nav>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => {
	const { loginData } = state;
	return {
		loginData
	};
};

export default connect(mapStateToProps)(Header);